import { RiArrowDownSLine } from '@/shared/icons/remix'

/** Figma 5181:9478 — arrow-up-s-line 2 (24×24 select chevron). */
export function SelectDropdownIcon({ className }: Readonly<{ className?: string }>) {
  return <RiArrowDownSLine className={className} size={24} aria-hidden />
}
